import React from "react";
import TablePerfil from "./tablePerfil";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import {
  checkAccess,
  ids,
  realCheckAccess,
} from "../../../../../helpers/rolAccess";
import { paths } from "../../../../../config/routes";

class Perfiles extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.userAccessIds !== this.props.userAccessIds) {
      this.props.dispatch(push(paths.root));
    }
  };

  render() {
    return (
      <div className="col-12 zero">
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <div className="col-12 zero">
            <TablePerfil handleModal={this.handleModal} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // perfiles: state.mantenedores.perfiles,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Perfiles);
